import React from "react";
import { Accordion, AccordionSummary, AccordionDetails, Typography, Grid, Box, Button, IconButton, TextField, CircularProgress } from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import DeleteIcon from "@mui/icons-material/Delete";
import SaveIcon from "@mui/icons-material/Save";
import NakdanButton from "../../SharedArea/NakdanButton";
import { observer } from "mobx-react-lite";
import additionalInfo from "../../../Mobx/AdditionalInfo";

const NewTrnsArSection = observer(() => {
    const newInfo = additionalInfo.newInfo;
    const expanded = additionalInfo.expandedState;
    const loading = additionalInfo.loading;

    const handleToggle = () => {
        additionalInfo.setExpandedState({ ...expanded, trnsAr: !expanded.trnsAr });
    };

    return (
        <Grid item xs={12}>
            <Accordion expanded={expanded.trnsAr} onChange={() => handleToggle("trnsAr")} sx={{ boxShadow: 3, borderRadius: 2, width: "100%" }}>
                <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                    <Typography variant="h6">({newInfo.trns_ar?.length || 0}) יצירת תרגום לערבית</Typography>
                </AccordionSummary>
                <AccordionDetails sx={{ width: "100%", textAlign: "center" }}>
                    <Button
                        variant="contained"
                        color="primary"
                        onClick={() => additionalInfo.createWithAi("trnsAr")}
                        sx={{ mb: 2 }}
                        disabled={loading.create.trnsAr}
                    >
                        {loading.create.trnsAr ? <CircularProgress size={24} /> : "צור"}
                    </Button>
                    <Box>
                        {newInfo.trnsAr?.length > 0 ? (
                            newInfo.trnsAr.map((trns_ar, index) =>
                                <Box key={index} sx={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "space-between", bgcolor: "#f0f0f0", p: 1, borderRadius: 2, mt: 0.5 }}>
                                    <Box sx={{ display: "flex", gap: 0, ml: 1 }}>
                                        {/* כפתור ניקוד */}
                                        <NakdanButton
                                            text={trns_ar}
                                            onNikudComplete={(nikudText) => {
                                                additionalInfo.editNewInfo("trnsAr", index, nikudText);
                                            }}
                                        />
                                        {/* כפתור שמירה */}
                                        <IconButton
                                            onClick={() =>
                                                additionalInfo.addExistsInfo({
                                                    fields: { trns_ar },
                                                    field: "trnsAr",
                                                    index
                                                })
                                            }
                                            disabled={additionalInfo.loading.addExistsInfo.trnsAr?.[index]}
                                        >
                                            {trns_ar && (additionalInfo.loading.addExistsInfo.trnsAr?.[index] ? <CircularProgress size={24} /> : <SaveIcon color="primary" />)}
                                        </IconButton>
                                        {/* כפתור מחיקה */}
                                        <IconButton onClick={() => additionalInfo.deleteNewInfo("trnsAr", index)}>
                                            <DeleteIcon color="error" />
                                        </IconButton>
                                    </Box>
                                    {/* שדה טקסט לעריכה */}
                                    <TextField
                                        fullWidth
                                        variant="outlined"
                                        size="small"
                                        multiline
                                        minRows={1}
                                        value={trns_ar}
                                        onChange={(e) => additionalInfo.editNewInfo("trnsAr", index, e.target.value)}
                                        sx={{ direction: /^[\u0590-\u05FF]/.test(trns_ar) ? "ltr" : "rtl" }}
                                    />
                                </Box>
                            )
                        ) : (
                            <Typography variant="body2" color="textSecondary">לא נוצרו תרגומים לערבית</Typography>
                        )}
                    </Box>
                </AccordionDetails>
            </Accordion>
        </Grid>
    );
});

export default NewTrnsArSection;
